// import

import {styled, keyframes} from 'goober';
import {setLightness} from 'polished';
import type {ComponentProps} from 'react';

import {Image} from 'modules/Image';
import {Link} from 'modules/Link';

// types

type Props = ComponentProps<typeof Div> & {
  coverImage: string;
  coverColor: string;
  title: string;
  href?: string;
};

// component

export function Book(props: Props) {
  const {coverImage, coverColor, title, ...rest} = props;
  const col = setLightness(0.1, coverColor);

  return (
    <Div
      {...rest}
      // @ts-expect-error missing type
      as={rest.href || rest.onClick ? Link : 'div'}
      style={{'--color': col}}
    >
      <div className="book">
        <div className="cover">
          <Image
            alt={title}
            height="1500"
            layout="responsive"
            src={coverImage}
            width="1000"
          />
        </div>
      </div>
    </Div>
  );
}

// styles

const anim = keyframes`
0% {
  transform: rotateY(-15deg);
}
50% {
  transform: rotateY(-30deg);
}
100% {
  transform: rotateY(-15deg);
}
`;

const Div = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 800px;

  .book {
    width: 100%;
    padding-top: 150%;
    position: relative;
    transform-style: preserve-3d;
    transform: rotateY(-15deg);
    transition: transform 0.5s ease-in-out;
    animation: ${anim} 0.5s ease-in-out 0.5s;

    &::before {
      content: "";
      position: absolute;
      right: 0.125rem;
      top: 0.125rem;
      bottom: 0.125rem;
      width: 30px;
      transform-origin: right center;
      transform: rotateY(-90deg);
      background:
        linear-gradient(
          90deg,
          var(--white) 0%,
          var(--gray) 10%,
          var(--white) 20%,
          var(--gray) 30%,
          var(--white) 40%,
          var(--gray) 50%,
          var(--white) 60%,
          var(--gray) 70%,
          var(--white) 80%,
          var(--gray) 90%,
          var(--white) 100%
        );
    }

    &::after {
      padding-top: 150%;
      content: "";
      transform: translateZ(-30px);

      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 0.125rem 0.25rem 0.25rem 0.125rem;
      background-color: var(--color, var(--gray-30));
    }

    &:hover {
      transform: rotateY(-30deg);
    }
  }

  .cover {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0.125rem 0.25rem 0.25rem 0.125rem;
    transform: translateZ(0);
    background-color: var(--color, var(--gray-30));
    overflow: hidden;

    &::before {
      content: "";
      padding-top: 150%;
    }
  }
`;
